import { IntegrationService } from '../../../../../../services/exports/Constants';

export default {
  title: 'Integraties',
  services: {
    [IntegrationService.Tabless]: 'Tabless',
    [IntegrationService.WinOrder]: 'WinOrder',
    [IntegrationService.ExpertOrder]: 'ExpertOrder',
    [IntegrationService.Deliverect]: 'Deliverect',
    [IntegrationService.Liefersoft]: 'Liefersoft',
    [IntegrationService.Hubrise]: 'HubRise',
  },
  labels: {
    no_integrations: '{{company}} heeft geen integraties geconfigureerd.',
  },
  buttons: {
    add_integration: 'Integratie toevoegen',
  },
  toasts: {
    error: 'Opslaan van wijzigingen mislukt',
    success: 'Wijzigingen opgeslagen',
    load_error: 'Laden van integraties mislukt',
  },
};
